import React, { useState } from 'react';
import { gql, useMutation, useQuery } from "@apollo/client";
import '../App.css';

const CREAR_PRODUCTO = gql`
mutation crearProducto($nombre: String, $imagen: String, $precio: Decimal, $codigo: String, $stock: Int) {
  crearProducto(nombre: $nombre, imagen: $imagen, precio: $precio, codigo: $codigo, stock: $stock) {
    _id
    nombre
    precio
    stock
    codigo
    imagen
  }
}`;

const GET_PRODUCTO = gql`
query getProductos {
  getProductos {
    _id
    nombre
    imagen
    precio
    codigo
    stock
  }
}`;

const ACTUALIZAR_PRODUCTO = gql`
mutation editarProducto($id: ID!, $nuevoNombre: String, $nuevaImagen: String, $nuevoCodigo: String, $nuevoStock: Int, $nuevoPrecio:Decimal) {
  editarProducto(_id: $id, nombre: $nuevoNombre, imagen: $nuevaImagen, codigo: $nuevoCodigo, stock: $nuevoStock, precio: $nuevoPrecio) {
    _id
    nombre
    precio
    stock
    codigo
    imagen
  }
}`;

const ELIMINAR_PRODUCTO = gql`
mutation eliminarProducto($id: ID!) {
  eliminarProducto(_id: $id)
}`;

function BuscarAgregar() {
  const { loading, error, data } = useQuery(GET_PRODUCTO);
  const [editingProduct, setEditingProduct] = useState(null);
  const [nuevoNombre, setNuevoNombre] = useState('');
  const [nuevaImagen, setNuevaImagen] = useState('');
  const [nuevoCodigo, setNuevoCodigo] = useState('');
  const [nuevoStock, setNuevoStock] = useState(0);
  const [nuevoPrecio, setNuevoPrecio] = useState(0);
  const [editarProducto] = useMutation(ACTUALIZAR_PRODUCTO);

  const [codigoBusqueda, setCodigoBusqueda] = useState('');
  const [productoEncontrado, setProductoEncontrado] = useState(null);

  const [nombre, setNombre] = useState('');
  const [precio, setPrecio] = useState(0);
  const [stock, setStock] = useState(0);
  const [codigo, setCodigo] = useState('');
  const [imagen, setImagen] = useState('');
  const [crearProducto] = useMutation(CREAR_PRODUCTO, {
    refetchQueries: [{ query: GET_PRODUCTO }],
  });

  const productoSubmit = e => {
    e.preventDefault();
    crearProducto({ variables: { nombre, precio, stock, codigo, imagen } });
    setNombre('');
    setPrecio(0);
    setStock(0);
    setCodigo('');
    setImagen('');
  }

  const handleBuscarProducto = (codigoBusqueda) => {
    if (!data) return;
    const producto = data.getProductos.find(prod => prod.codigo === codigoBusqueda);
    setProductoEncontrado(producto || null);
  }

  const handleLimpiarBusqueda = () => {
    setCodigoBusqueda('');
    setProductoEncontrado(null);
  }

  const [eliminarProducto] = useMutation(ELIMINAR_PRODUCTO, {
    refetchQueries: [{ query: GET_PRODUCTO }]
  });

  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error</p>;

  return (
    <div>
      <div   style={{
        background: "#00ff4c1c",
        border: "3px solid #519701",
        color: ' #013a1f',
        borderRadius: "10px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        padding: "30px",
        maxWidth: "700px",
        margin: "40px auto",
        fontFamily: "Arial, sans-serif",
      }}>
        <div className="card-body">
          <h2 className="card-title">Buscar Producto</h2>
          <input
            placeholder="Buscar por código de barras"
            value={codigoBusqueda}
            onChange={evt => {
              const value = evt.target.value;
              setCodigoBusqueda(value);
              handleBuscarProducto(value);
            }}
          />
          <button className="btn btn-danger" onClick={handleLimpiarBusqueda}>borrar</button>

          {productoEncontrado ? (
            <div>
              <h3>Producto encontrado:</h3>
              <p>Nombre: {productoEncontrado.nombre}</p>
              <p>Precio: {productoEncontrado.precio}</p>
              <p>Stock: {productoEncontrado.stock}</p>
              <p>Código: {productoEncontrado.codigo}</p>
              <img src={productoEncontrado.imagen} alt={productoEncontrado.nombre} width="80px" />
              <button className="btn btn-danger" onClick={() => {
                eliminarProducto({ variables: { id: productoEncontrado._id } });
              }} disabled={loading}>
                eliminar
              </button>

              {editingProduct === productoEncontrado._id ? (
                <>
                  <p>Producto</p>
                  <input
                    type="text"
                    value={nuevoNombre}
                    onChange={(e) => setNuevoNombre(e.target.value)}
                  />
                  <p>codigo</p>
                  <input
                    type="text"
                    value={nuevoCodigo}
                    onChange={(e) => setNuevoCodigo(e.target.value)}
                  />
                  <p>Imagen(url)</p>
                  <input
                    type="text"
                    value={nuevaImagen}
                    onChange={(e) => setNuevaImagen(e.target.value)}
                  />
                  <p>unidades disponibles</p>
                  <input
                    type="number"
                    value={nuevoStock}
                    onChange={(e) => setNuevoStock(parseInt(e.target.value))}
                  />
                  <p>Precio</p>
                  <input
                    placeholder='precio'
                    value={nuevoPrecio}
                    onChange={evt => setNuevoPrecio(evt.target.value)} 
                    type="number"
                    step="0.01"
                  />
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      editarProducto({
                        variables: { id: productoEncontrado._id, nuevoNombre, nuevaImagen, nuevoCodigo, nuevoStock, nuevoPrecio },
                      });
                      setEditingProduct(null);
                      setNuevoNombre('');
                      setNuevoCodigo('');
                      setNuevaImagen('');
                      setNuevoStock(0);
                      setNuevoPrecio(0);
                    }}
                  >
                    Guardar
                  </button>
                </>
              ) : (
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setEditingProduct(productoEncontrado._id);
                    setNuevoNombre(productoEncontrado.nombre);
                    setNuevoCodigo(productoEncontrado.codigo);
                    setNuevaImagen(productoEncontrado.imagen);
                    setNuevoStock(productoEncontrado.stock);
                    setNuevoPrecio(productoEncontrado.precio);
                  }}
                >
                  Editar
                </button>
              )}
            </div>
          ) : (
            codigoBusqueda && (
              <div>
                <h2>Agregar nuevo producto</h2>
                <form onSubmit={productoSubmit}>
                  <h6>Producto</h6>
                  <input placeholder='nombre' value={nombre} onChange={evt => setNombre(evt.target.value)}></input>
                  <h6>Precio</h6>
                  <input
                    placeholder='precio'
                    value={precio}
                    onChange={evt => setPrecio(evt.target.value)} 
                    type="number"
                    step="0.01"
                  />
                  <h6>Codigo de barras</h6>
                  <input placeholder='codigo' value={codigo} onChange={evt => setCodigo(evt.target.value)}></input>
                  <h6>Stock</h6>
                  <input placeholder='stock' value={stock} onChange={evt => setStock(parseInt(evt.target.value))}></input>
                  <h6>Url de la imagen</h6>
                  <input placeholder='imagen' value={imagen} onChange={evt => setImagen(evt.target.value)}></input>
                  <button className="btn btn-salida">Agregar producto</button>
                </form>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default BuscarAgregar;
